import { useTranslation } from 'next-i18next';
import React from 'react';

import { ProductVariantGroup } from '../../../../components/Content/ProductAbstract/ProductVariants';
import { VariantIcon } from '../../../../components/Content/VariantIcon';
import { UNFRAMED_IMAGE } from '../../../../constants';
import { Frame, FrameOptionConsolidated } from '../../../../types/Products';

interface ProductFrameSelectorProps {
  frame: Frame | null;
  frameIncluded: boolean;
  frames: FrameOptionConsolidated[] | null;
  onFrameChange: (frame: Frame | null) => void;
  product: ProductType | null;
}

export const ProductFrameSelector: React.FC<ProductFrameSelectorProps> = ({
  frame,
  frameIncluded,
  frames,
  onFrameChange,
  product,
}) => {
  const { t } = useTranslation('product');

  if (product === null || !frames?.length) {
    return null;
  }

  const clearFrame = () => void onFrameChange(null);

  return (
    <div className="flex w-full flex-col flex-wrap items-center justify-center gap-y-4 empty:hidden sm:flex-row sm:divide-x sm:divide-divider/20">
      <ProductVariantGroup>
        {frameIncluded ? null : (
          <button onClick={clearFrame} type="button">
            <VariantIcon
              active={!frame}
              thumbnail={UNFRAMED_IMAGE}
              tooltipText={t('framing.tooltips.unframed')}
            />
          </button>
        )}
        {frames &&
          frames.map((availableFrame) => (
            <button
              key={availableFrame.title}
              onClick={() => {
                const { variants: submitVariants, ...selectedFramesRest } =
                  availableFrame;
                onFrameChange({
                  ...selectedFramesRest,
                  variant: submitVariants[0],
                });
              }}
              type="button"
            >
              <VariantIcon
                active={frame?.title === availableFrame.title}
                text="F"
                thumbnail={availableFrame.images[0].src}
                tooltipText={availableFrame.title}
              />
            </button>
          ))}
      </ProductVariantGroup>
    </div>
  );
};
